import { alpha } from "@mui/material"
import { COLORS } from "../../../styles/variables"

export const ContainerBoxStyle = {
    width: 120,
    height: 120,
    borderRadius: "8px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: COLORS.CATSKILL_WHITE,
    border: `1px solid ${COLORS.LINK_WATER}`,
}

export const BoxImageIconStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: "8px",
    overflow: 'hidden',
}

export const BoxImgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: "8px",
}

export const IconButtonStyle = {
    position: 'absolute' as const,
    top: 5,
    right: 5,
    backgroundColor: COLORS.WHITE,
    width: 28,
    height: 28,
}

export const avatarPreloadOverlayStyle = {
    position: "absolute" as const,
    inset: 0,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    bgcolor: alpha(COLORS.BLACK, 0.35),
    pointerEvents: "auto" as const,
    cursor: "wait" as const,
}